import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import { Link, useParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";
import { toast } from "react-toastify";
import { addFaq, editFaq, faqDetails } from "../../../../store/actions";
import { useNavigate } from "react-router-dom";

const AddFaq = () => {
  const navigate = useNavigate();
  const EditId = location.pathname.split("/")[4];
  const statusRef = useRef();
  const dispatch = useDispatch();
  const compMounted = useRef();
  const [addfaq, setAddfaq] = useState({
    FaqId: "",
    question: "",
    answer: "",
  });
  console.log(addfaq, "ddfdgffddg");
  const [errors, setError] = useState({
    question: "",
    answer: "",
    disabled: true,
  });
  const Faqdetails = useSelector((s) => s.FaqReducer.faqDetails?.data);

  useEffect(() => {
    if (compMounted.current) {
      setAddfaq((pre) => ({
        ...pre,
        question: Faqdetails?.question,
        answer: Faqdetails?.answer,
      }));
    } else {
      compMounted.current = true;
    }
  }, [Faqdetails]);
  const handleChange = (e) => {
    const { name, value } = e.target;
    const Error = { ...errors };

    switch (name) {
      case "question":
        Error[name] = "";
        if (value.length < 4) {
          Error[name] = "Required";
          Error["disabled"] = true;
        } else {
          Error["disabled"] = false;

          ("");
        }
        break;
      case "answer":
        Error[name] = "";
        if (value.length < 4) {
          Error[name] = "Required";
          Error["disabled"] = true;
        } else {
          Error["disabled"] = false;

          ("");
        }
        break;

      default:
        break;
    }
    setAddfaq((prevState) => ({
      ...prevState,
      [name]: value,
    }));
    setError((pre) => ({ ...pre, ...Error }));
  };
  useEffect(() => {
    if (EditId) {
      dispatch(faqDetails(EditId));
    }
    setAddfaq((pre) => ({
      ...pre,
      FaqId: EditId,
    }));
  }, [EditId]);

  const handleSubmit = (e) => {
    e.preventDefault();
    const callBack = (response) => {
      if (response.status == "success") {
        toast.success(response.message);
        setTimeout(() => {
          navigate("/configuration/faq");
        }, 500);
      } else {
        toast.error(response.message);
      }
    };
    if (EditId) {
      if (addfaq.FaqId) {
        addfaq.FaqId = addfaq.FaqId;
      }
      dispatch(editFaq(addfaq, callBack));
    } else {
      dispatch(addFaq(addfaq, callBack));
    }
  };

  return (
    <>
      <section className="addFaq py-3 position-relative">
        <Container>
          <Row className="justify-content-center">
            <Col lg="12" className="my-2">
              <Link to="/configuration/faq" className="">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="41"
                  height="41"
                  viewBox="0 0 41 41"
                  fill="none"
                >
                  <rect
                    x="0.5"
                    y="0.5"
                    height="40"
                    rx="11.5"
                    fill="white"
                    stroke="#D9DADC"
                  />
                  <path
                    d="M23.1573 13.3669C23.0654 13.2747 22.9562 13.2016 22.836 13.1517C22.7157 13.1019 22.5869 13.0762 22.4567 13.0762C22.3265 13.0762 22.1976 13.1019 22.0774 13.1517C21.9572 13.2016 21.848 13.2747 21.7561 13.3669L15.1773 19.9456C15.1039 20.0189 15.0457 20.1059 15.006 20.2017C14.9662 20.2974 14.9458 20.4001 14.9458 20.5038C14.9458 20.6075 14.9662 20.7101 15.006 20.8059C15.0457 20.9017 15.1039 20.9887 15.1773 21.0619L21.7561 27.6406C22.144 28.0286 22.7694 28.0286 23.1573 27.6406C23.5452 27.2527 23.5452 26.6273 23.1573 26.2394L17.4257 20.4998L23.1652 14.7602C23.5452 14.3802 23.5452 13.7469 23.1573 13.3669Z"
                    fill="#1E232C"
                    stroke="#1E232C"
                    stroke-width="0.2"
                  />
                </svg>
              </Link>
            </Col>
            <Col lg="9" className="my-2">
              <Form onSubmit={handleSubmit}>
                <div className="formWrpper px-sm-4 box p-3 pb-5">
                  <Row>
                    <Col md="12" className="my-2">
                      <label
                        htmlFor=""
                        className="form-label m-0 fw-sbold text-muted ps-2"
                      >
                        QUESTIONS
                      </label>
                      <input
                        type="text"
                        className="form-control bg-white"
                        name="question"
                        value={addfaq?.question}
                        onChange={handleChange}
                      />
                    </Col>
                    <Col md="12" className="my-2">
                      <label
                        htmlFor=""
                        className="form-label m-0 fw-sbold text-muted ps-2"
                      >
                        Subject
                      </label>
                      <CKEditor
                        editor={ClassicEditor}
                        data={EditId ? addfaq?.answer : ""}
                        onReady={(editor) => {
                          console.log("Editor is ready to use!", editor);
                        }}
                        onChange={(event, editor) => {
                          const data = editor.getData();
                          setAddfaq((pre) => ({
                            ...pre,
                            answer: data,
                          }));
                        }}
                        onBlur={(event, editor) => {
                          // console.log("Blur.", editor);
                        }}
                        onFocus={(event, editor) => {
                          // console.log("Focus.", editor);
                        }}
                      />
                    </Col>
                  </Row>
                </div>
                <div className="btnWrpper mt-4 text-center">
                  <Button
                    className="d-inline-flex h-auto align-items-center justify-content-center commonBtn px-5"
                    type="submit"
                  >
                    Save
                  </Button>
                </div>
              </Form>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default AddFaq;
